export enum DropDownElementsBlockType {
    OrderedList = `ordered_list`,
    UnOrderedList = `un_ordered_list`,
    Text = `text`,
}
